import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Button, Header, Icon, Modal, Grid, Popup } from 'semantic-ui-react';
import { InputField, DropDown } from 'KN-EU-Broker-Dashboard-UI'
import { useSelector, useDispatch } from 'react-redux';
import { reInitState, updateFieldValue } from '../../slices/createShipmentSlice';
import { ReconGlobalContext } from '../providers/ReconGlobalProvider';
import { importerIdTypeData, importerIdTypeOptions, importerIdValidation, reconTypeVal } from '../../constants';
import { getImporterList } from '../../util/index';
import { isEmpty } from 'lodash';
import useCreateJob from '../../hooks/useCreatejob';
import MessageModal from '../commonComponents/MessageModal.js';

const CreateShipmentModal = (props) => {
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const [secondOpen, setSecondOpen] = useState(false);
  const [errors, setErrors] = useState({
    importerOfRecordNumber:[] 
  });
  const [displayMsg, setDisplayMsg] = useState({color: "black", message: "", title: ""});
  const { isModal, setIsModal, userGuid, filerCode, processingPort } = props;
  const createShipmentData = useSelector((state) => state.createReconShipment)
  const { importerCode, importerOfRecordNumber, comment, reconciliationTypeCode, importerOfRecordType } = createShipmentData;
  const dispatch = useDispatch();
  const {createReconJob, isLoading: createReconJobLoader} = useCreateJob(setDisplayMsg, setSecondOpen);

  const {kxUser: {channelConnections: {customersConnected:importerList=[]}={}}} = useContext(ReconGlobalContext);
  const importerData = useMemo(() => (
    getImporterList(importerList)
  ), [importerList])
  
  const createJobHandler =()=>{
    setDisplayMsg({color:"black", message: "", title: ""})
    const importerEmail = importerList.filter((item, index) => {
      if(item.customerCode === importerCode){
        return item.email;
      }
    })
    createReconJob(importerCode, userGuid, reconciliationTypeCode, importerOfRecordNumber, importerOfRecordType, filerCode, importerEmail[0]?.customerKxEmail, processingPort, "A", "US", comment);
  }
  useEffect(() => {
    if(importerOfRecordType){
      if(!importerIdValidation[importerOfRecordType]?.formatRegex.test(importerOfRecordNumber)){
        setErrors({...errors, importerOfRecordNumber: `Please Match the pattern ${importerIdValidation[importerOfRecordType]?.formatDescription}`})
      }
      else{
        setErrors({...errors, importerOfRecordNumber: ""})
      }
    }
  }, [importerOfRecordNumber, importerOfRecordType])

  useEffect(() => {
    if(isEmpty(importerCode) || isEmpty(importerOfRecordNumber) || isEmpty(comment) || isEmpty(reconciliationTypeCode) || isEmpty(importerOfRecordType) || !isEmpty(errors.importerOfRecordNumber) || displayMsg.color === "green" || createReconJobLoader){
      setSubmitEnabled(false);
    }
    else{
      setSubmitEnabled(true);
    }
  }, [importerCode, importerOfRecordNumber, comment, reconciliationTypeCode, importerOfRecordType, errors, displayMsg, createReconJobLoader])

  const onChange = ({target: {name, value}}) => {
    dispatch(updateFieldValue({name, value}));
  };
  const onDropDownChange = (e, {name, value}) => {
    dispatch(updateFieldValue({name, value}))
  }

  return (
    <Modal
      open={isModal}
      onClose={() => setIsModal(false)}
      onOpen={() => setIsModal(true)}
    >
      <Header
        style={{ height: '85px' }}
        content='Create New Reconciliation Shipment'
      />
      <Modal.Content style={{ width: 'auto' }}>
          <Grid columns={5} className="responsiveGridCss1">
            <Grid.Row>
              <Grid.Column>
                <DropDown
                  label={'IMPORTER NAME'}
                  name="importerCode"
                  value={importerCode}
                  data={importerData}
                  onChange={onDropDownChange}
                />
              </Grid.Column>
              <Grid.Column>
                <DropDown
                  label={'ID Type'}
                  name="importerOfRecordType"
                  value={importerOfRecordType}
                  data={importerIdTypeData}
                  onChange={onDropDownChange}
                />
              </Grid.Column>
              <Grid.Column>
                <InputField
                  label={`IMPORTER ID ${importerIdValidation[importerOfRecordType] ? `[${importerIdValidation[importerOfRecordType]?.formatDescription}]` : ""}`}
                  name="importerOfRecordNumber"
                  value={importerOfRecordNumber}
                  errors={errors.importerOfRecordNumber}
                  onChange={onChange}
                />
              </Grid.Column>
              <Grid.Column>
                <InputField
                  label={'COMMENTS / REFERENCE'}
                  name="comment"
                  value={comment}
                  onChange={onChange}
                />
              </Grid.Column>
              <Grid.Column>
                <DropDown
                  label={'RECNCILIATION TYPE'}
                  name="reconciliationTypeCode"
                  value={reconciliationTypeCode}
                  data={reconTypeVal}
                  onChange={onDropDownChange}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button compact className="modal-recon-button" onClick={() => setIsModal(false)}>
          Close
        </Button>
        <Button
          compact
          color='green'
          disabled={!submitEnabled}
          onClick={() => {
            createJobHandler();
          }}
        >
          {createReconJobLoader ? <>Creating...</> : <>Create</>}
        </Button>
      </Modal.Actions>
      <MessageModal displayMsg={displayMsg} open={secondOpen} setOpen={setSecondOpen} setParentModal={setIsModal} />
    </Modal>
  );
};

export default CreateShipmentModal;
